declare const VueBridge: {
    getInstance: () => VueBridgeClass;
};

export type ScreenChangeCallBack = (isRefreshMenu: boolean) => void;

declare class VueBridgeClass {
    buildDate: string
    getInstance: () => VueBridgeClass;
    fireEvent: (eventName: string) => void;
    loadScreen: (hashToken: string) => void;
    forceReload: () => void;
    needSave: () => boolean;
    clearNeedSave: () => void;
    addScreenChangeHandler: (screenChangeCallback: ScreenChangeCallBack) => void;
}

/** Access the VueBridge by putting a callback on this promise */
export const gwtBridge: Promise<VueBridgeClass> = new Promise((resolve) => {
    const intervalId = setInterval(() => {
        if(typeof VueBridge !== 'undefined'
            && typeof VueBridge.getInstance !== 'undefined'
            && typeof VueBridge.getInstance() !== 'undefined') {
            clearInterval(intervalId);
            resolve(VueBridge.getInstance());
        }
    }, 100);
});